import React, { useMemo } from 'react'
import { allDepthOfKnowledgeMap } from '@edulastic/constants/const/question'
import { IconEditMetaData } from '@edulastic/icons'

import {
  QuestionDetails,
  DetailRow,
  FlexWrap,
  MetadataValueRow,
  MetadataFieldEditButton,
  StandardsValueRow,
} from './styled'
import Standards from '../../../../ItemList/components/Item/Standards'
import { getAllRubricNames } from '../../../utils/util'

const MetadataFieldEditIcon = ({ onClick, 'data-cy': dataCy, ariaLabel }) => (
  <MetadataFieldEditButton
    type="button"
    data-cy={dataCy}
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <IconEditMetaData width={15} height={15} fill="#158463" aria-hidden />
  </MetadataFieldEditButton>
)

const QuestionPreviewDetails = ({
  id,
  createdBy,
  maxScore,
  depthOfKnowledge,
  authorDifficulty,
  bloomsTaxonomy,
  tags,
  item,
  showAllInterestedCurriculums,
  showFieldEditIcons,
  onFieldEditClick,
  metadataEditBlock,
}) => {
  const allRubricNames = useMemo(() => {
    return getAllRubricNames(item)
  }, [item])
  const { unsavedItem } = item

  const renderEditIcon = (dataCy, ariaLabel) =>
    showFieldEditIcons ? (
      <MetadataFieldEditIcon
        data-cy={dataCy}
        ariaLabel={ariaLabel}
        onClick={onFieldEditClick}
      />
    ) : null

  return (
    <QuestionDetails>
      <FlexWrap>
        <DetailRow font={11}>
          <label>ID: </label>
          <span data-cy="item-id-on-preview">
            {unsavedItem
              ? '--'
              : id?.length > 6
              ? id.substr(id.length - 6)
              : id || '--'}
          </span>
        </DetailRow>
        <DetailRow>
          <label>Owner: </label>
          <span data-cy="teacher-name-on-preview">
            {createdBy?.name || '--'}
          </span>
        </DetailRow>
        <DetailRow font={11}>
          <label>Points: </label>
          <span data-cy="points-on-preview">{maxScore || '--'}</span>
        </DetailRow>
      </FlexWrap>

      {metadataEditBlock}

      <FlexWrap border="none" justify="flex-start">
        <DetailRow direction="column">
          <label>Depth of Knowledge</label>
          <MetadataValueRow>
            <span data-cy="dok-on-preview">
              {allDepthOfKnowledgeMap[depthOfKnowledge]?.text || '--'}
            </span>
            {renderEditIcon(
              'preview-modal-edit-dok',
              'Edit Depth of Knowledge'
            )}
          </MetadataValueRow>
        </DetailRow>
        <DetailRow direction="column">
          <label>Difficulty Level</label>
          <MetadataValueRow>
            <span data-cy="diff-on-preview">{authorDifficulty || '--'}</span>
            {renderEditIcon(
              'preview-modal-edit-difficulty',
              'Edit Difficulty Level'
            )}
          </MetadataValueRow>
        </DetailRow>
        <DetailRow direction="column">
          <label>Bloom’s Taxonomy</label>
          <span data-cy="tax-on-preview">{bloomsTaxonomy || '--'}</span>
        </DetailRow>
        <DetailRow direction="column" alignItems="flex-start">
          <label>Rubric</label>
          <MetadataValueRow>
            <span data-cy="rubricOnPreview">
              {allRubricNames.length ? allRubricNames.join(', ') : '--'}
            </span>
            {allRubricNames.length
              ? renderEditIcon('preview-modal-edit-rubric', 'Edit Rubric')
              : null}
          </MetadataValueRow>
        </DetailRow>
      </FlexWrap>

      <FlexWrap border="none" direction="column" align="flex-start">
        <DetailRow className="standards">
          <label>Standard: </label>
          <StandardsValueRow data-cy="standards-on-preview">
            <Standards
              item={item}
              show={7}
              showAllInterestedCurriculums={showAllInterestedCurriculums}
            />
            {renderEditIcon('preview-modal-edit-standards', 'Edit Standards')}
          </StandardsValueRow>
        </DetailRow>
        <DetailRow className="tags">
          <label>Tags: </label>
          <div data-cy="tags-on-preview">
            {(tags &&
              tags.length &&
              tags.map((tag) => <span>{tag?.tagName}</span>)) ||
              '--'}
          </div>
        </DetailRow>
      </FlexWrap>
    </QuestionDetails>
  )
}

export default QuestionPreviewDetails
